import React from 'react';
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";
import TableLine from "./TableLine";
import {Paper} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

class Skin extends React.Component {

    list = {
        facials: {
            head: ['Facials', 'Non-Members Price'],
            list : [
                ['Consultation', 50],
                ['Detox Deep Cleansing', 299],
                ['Sensitive Calming', 199],
                ['Acne Extractions', 249],
                ['Anti-Aging', 285],
                ['Men Facial', 160],
                ['Teen Facial', 130],
                ['Express Facial', 150],
                ['Aromatherapy Facial', 150],
                ['Mini Teen Facial', 60],
                ['Skin Tag Removal', 150]
            ]
        },
        treatments: {
            head: ['Advanced Treatments', 'Non-Members'],

            list : [
                ['Glow Vitamin C', 350],
                ['Dermaplane', 250],
                ['Microneedling Skin Rejuvenation', 450],
                ['Microneedling Acne Scare Treatment', 350],
                ['HydroFacial', 200],
                ['Cryo Therapy & Laser Rejuvenation', 450],
                ['Laser Facial', 500],
                ['Melasma & Hyperpigmentation Treatment', 350],
                ['Microdermabrasion', 250],
                ['Oxygen Skin Therapy', 300],
                ['Hifu Face Lift', 650],
                ['Vampire Velvet Peel', 250]
            ]
        },
        skin_members : {
            head: ['Name', 'Description', 'Price'],
            price1: ['Glow Skin', '1 Facial/mo', 125],
            price2: ['Skin Treatment', '1 Skin Treatment Facial/mo', 150],
        }
    };

    render() {
        return(
            <div>
                <Paper className='mx-3 mt-1 mb-3'>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={6}>
                            <Table>
                                <TableHead>
                                    <TableLine list={this.list.facials.head} head={true} />
                                </TableHead>
                                <TableBody>
                                    {
                                        this.list.facials.list.map(it => {
                                            return <TableLine list={it} head={false} />
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Table>
                                <TableHead>
                                    <TableLine list={this.list.treatments.head} head={true} />
                                </TableHead>
                                <TableBody>
                                    {
                                        this.list.treatments.list.map(it => {
                                            return <TableLine list={it} head={false} />
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper className='mx-3 mt-1 mb-3'>
                    <Table>
                        <TableHead>
                            <TableLine list={this.list.skin_members.head} head={true} membership={true}/>
                        </TableHead>
                        <TableBody>
                            <TableLine list={this.list.skin_members.price1} head={false} />
                            <TableLine list={this.list.skin_members.price2} head={false} />
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        )
    }
}

export default Skin;
